import Vue from 'vue';
import TextileCarousel from './carousel.vue';

export default function init(  slides  ) {
    window.carousel = new Vue({
        el: '#reviews-slider',
        data: {
            'slides': slides
        },
        render: function (createElement){
            return createElement(TextileCarousel, {
                props: {
                    slide: this.slides
                }
            })
        },
        components: {TextileCarousel}
    });
}